import { render, staticRenderFns } from "./StatsJerseyEdit.vue?vue&type=template&id=1a77c2bf&scoped=true&"
import script from "./StatsJerseyEdit.vue?vue&type=script&lang=js&"
export * from "./StatsJerseyEdit.vue?vue&type=script&lang=js&"
import style0 from "./StatsJerseyEdit.vue?vue&type=style&index=0&id=1a77c2bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a77c2bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
